export const graphMulti = {
    rolesCanShowBannerInfo: []
}